export const graphMulti = {
    rolesCanShowBannerInfo: []
}